export default __webpack_public_path__ + "static/media/icon-annual-leave-pm.903c075d.svg";